import { CheckboxState } from '@adsk/alloy-react-checkbox';

import { IdType, InternalDataNode, TreeSelectedIds } from '../types';

type CascadeMultiSelectionArgs = {
  normalizedTree: Record<IdType, InternalDataNode>;
  selectedIds: TreeSelectedIds;
  changes: {
    id: IdType;
    isSelected: CheckboxState;
  };
  includeParent?: boolean;
};
const cascadeMultiSelection = ({
  normalizedTree,
  selectedIds,
  changes,
  includeParent = true,
}: CascadeMultiSelectionArgs): TreeSelectedIds => {
  const treeNode = normalizedTree[changes.id];
  const parentIds = [...treeNode.path];
  const updatedSelectedIds: TreeSelectedIds = {
    ...selectedIds,
    [changes.id]: changes.isSelected,
  };
  // iterate up
  while (parentIds.length) {
    const currentParentNode = normalizedTree[parentIds[parentIds.length - 1]];
    const selectedChildCount = currentParentNode.childIds.reduce<number>(
      (count, childId) => {
        if (updatedSelectedIds[childId]) return count + 1;
        return count;
      },
      0,
    );
    let checkedState: CheckboxState = false;
    if (
      selectedChildCount === currentParentNode.childIds.length &&
      includeParent
    ) {
      checkedState = true;
    } else if (selectedChildCount > 0) {
      checkedState = 'indeterminate';
    }
    updatedSelectedIds[currentParentNode.id] = checkedState;
    parentIds.pop();
  }
  // traverse down
  const traverseDown = (currentNode: InternalDataNode) => {
    currentNode?.childIds?.forEach((childId) => {
      const childNode = normalizedTree[childId];
      updatedSelectedIds[childId] = changes.isSelected;
      traverseDown(childNode);
    });
  };
  traverseDown(treeNode);

  return updatedSelectedIds;
};

export default cascadeMultiSelection;
